import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, timeout } from 'rxjs';

export function timeoutInterceptor(_req: HttpRequest<any>, _handler: HttpHandlerFn): Observable<HttpEvent<any>> {
	const _timeout: int = Number(_req.headers.get('timeout') || 0);

	if (_timeout)
		return _handler(_req).pipe(timeout(_timeout));

	return _handler(_req);
}
